import { filterExisting } from 'as-ui-kit/utils/arrays';

const substitutionRegExp = /{{([\w\d]+)}}/g;

/**
 * Делает первую букву строки прописной
 * @example capitalize('abcd') => 'Abcd'
 * @param {string} string - Строка для преобразования
 */
export const capitalize = string => string.substr(0, 1).toUpperCase() + string.substr(1);

/**
 * Делает первую букву строки строчной
 * @example unCapitalize('ABCD') => 'aBCD'
 * @param {string} string - Строка для преобразования
 */
export const unCapitalize = string => string.substr(0, 1).toLowerCase() + string.substr(1);

/**
 * Переводит строку из `snake_case` в `PascalCase`
 * @example snakeToPascal('snake_case') => 'SnakeCase'
 * @param {string} string - Строка для преобразования
 */
export const snakeToPascal = string => string.split('_').map(capitalize).join('');

/**
 * Переводит строку из `snake_case` в `camelCase`
 * @example snakeToPascal('snake_case') => 'camelCase'
 * @param {string} string - Строка для преобразования
 */
export const snakeToCamel = string => unCapitalize(snakeToPascal(string));

/**
 * Переводит строку из `PascalCase` в `snake_case`
 * @example snakeToPascal('PascalCase') => 'pascal_case'
 * @param {string} string - Строка для преобразования
 */
export const pascalToSnake = string =>
    string
        .split(/(?=[A-Z])/)
        .map(str => str.toLowerCase())
        .join('_');

/**
 * Интерполяция строки
 * @example interpolate('{{one}}, {{two}}', {one: 1, two: 2}) => '1, 2'
 * @param {string} str - Сторка для интерполяции
 * @param {object} values - Объект с интерполируемыми значениями
 */
export const interpolate = (str, values) => str.replace(substitutionRegExp, (match, group0) => values[group0]);

/**
 * Делает Regexp-строку обычной строкой
 * @param {string} str - Строка для преобразования
 */
export const escapeRegExp = str => str.replace(/[-[\]\\/{}()*+?.^$|]/g, '\\$&');

/**
 * Выбирает нужную строку в зависимости от числа
 * @param {Number} number — Число
 * @param {[string, string, string]} titles — Строки для выбора (один, несколько, много)
 * @returns {string}
 */
export const pluralize = (number, titles) =>
    titles[number % 100 > 4 && number % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? number % 10 : 5]];

/**
 * Соединяет строчки в предложение
 * @param {string[]} parts - Массив строчек для соединения
 * @param {string} lastSeparator - Разделитель перед последней строчкой
 * @param {boolean} dotAtTheEnd - Ставить ли точку в конце
 */
export const joinToSentence = (parts, lastSeparator = ',', dotAtTheEnd) =>
    parts.reduce((prev, cur, idx) => {
        let partSeparator;
        if (idx > 0) {
            partSeparator = idx === parts.length - 1 ? `${lastSeparator} ` : ', ';
        } else {
            partSeparator = '';
        }

        return `${prev}${partSeparator}${cur}`;
    }, '') + (dotAtTheEnd ? '.' : '');

/**
 * Переворачивает сторку
 * @param string - Строка, которую нужно превернуть
 * @returns {string} - Перевернутая срока
 */
export const reverse = string => string.split('').reverse().join('');

const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);

/**
 * Создает валидный GUID
 */
export const GUID = () => s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();

/**
 * Какая-то хуета, не сразу понятно как оно ваще не падает
 */
export const formatPhoneString = value => {
    value = event.target.value.replace(/[^0-9\-\s+()]/g, '');
    value = value.replace(/\s{2,}/g, ' ');
    value = value.replace(/\({2,}/g, '(');
    value = value.replace(/\){2,}/g, ')');
    value = value.replace(/\+{2,}/g, '+');

    return value;
};

export const formatDigitsOnlyString = value => {
    if (!value) return null;
    value = value.replace(/([^\d])/g, '');

    return value;
};

export const formatDepartmentCodeString = value => {
    if (!value) return null;
    value = value.replace(/[^\d]/g, '');
    if (value.length >= 3) {
        value = value.slice(0, 3) + '-' + value.slice(3, 6);
    }

    return value;
};

/**
 * Возвращает количество цифр в строке
 * @example
 * significantDigitsCount('x1x2x3-x4x5') // -> 5
 *
 * @param {string} str
 */
export const significantDigitsCount = str => {
    if (!str) return 0;
    try {
        const clearString = str.replace(/[^0-9]/g, '');
        const parsedNumber = parseInt(clearString, 10);
        return parsedNumber.toString(10).length;
    } catch {
        return 0;
    }
};

export const joinExisting = (separator, ...parts) => filterExisting(parts).join(separator);

/**
 * Убирает из строки все нецифровые символы.
 * @param {string} string
 */
export const stripNonNumericChars = string => string.replace(/\D/g, '');


/**
 * Проверяет строку на UUID
 * @param {string} str
 */
export const isUUID = str => {
    const regexUUID = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    return regexUUID.test(str);
};

/**
 * Проверяет строку на snake_case
 * @param {string} str
 */
export const isSnakeCase = str => str.includes('_');

/**
 * Проверяет строку на PascalCase
 * @param {string} str
 */
export const isPascalCase = str => str[0] && str[0] === str[0].toUpperCase();